import React, { useEffect, useState } from "react";
import { useTheme } from "next-themes";

interface LogoProps {
  width?: number;
  height?: number;
  showText?: boolean;
  forceDark?: boolean;
  inFooter?: boolean;
}

export function Logo({ width = 220, height = 60, showText = true, forceDark = false, inFooter = false }: LogoProps) {
  const { resolvedTheme, theme } = useTheme();
  const [mounted, setMounted] = useState(false);
  
  // 在客户端挂载后才能访问theme
  useEffect(() => {
    setMounted(true);
  }, []);
  
  // 确定当前主题
  const isDark = forceDark || 
    (mounted && (resolvedTheme === "dark" || 
    (!resolvedTheme && theme === "dark") || 
    (!resolvedTheme && !theme && window.matchMedia('(prefers-color-scheme: dark)').matches)));
  
  // 配色方案 - 与页面保持一致
  const iconColor = isDark ? "#6366f1" : "#2563eb"; // 图标颜色 (indigo-600 : blue-600)
  const textColor = isDark ? "#f9fafb" : "#111827"; // 文字颜色 (gray-50 : gray-900)
  const checkColor = isDark ? ( inFooter ? "#27272A" : "#18181b") : "#f9fafb"; // 对勾颜色 - 与header背景色匹配 (zinc-900 : white)
  
  // 防止初始渲染闪烁
  if (!mounted) {
    // 提供一个默认的静态版本用于服务端渲染和初始客户端渲染
    /*return (
      <svg 
        width={width} 
        height={height} 
        viewBox="0 0 220 60" 
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Communicate to Win Logo"
      >
        <g transform="translate(5, 5) scale(0.25)">
          <path 
            d="M20,20 h160 a10,10 0 0 1 10,10 v80 a10,10 0 0 1 -10,10 h-100 l-30,30 v-30 h-30 a10,10 0 0 1 -10,-10 v-80 a10,10 0 0 1 10,-10 z" 
            fill="#2563eb"
          />
          <path 
            d="M20,20 L100,140 L180,20" 
            fill="none" 
            stroke="#f9fafb"
            strokeWidth="15" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </g>
        
        {showText && (
          <g transform="translate(65, 0)">
            <text 
              x="0" 
              y="25" 
              fontFamily="Arial" 
              fontSize="18" 
              fontWeight="bold"
              fill="#111827"
            >
              Communicate
            </text>
            <text 
              x="0" 
              y="48" 
              fontFamily="Arial, Helvetica, sans-serif" 
              fontSize="28" 
              fontWeight="bold"
              fill="#111827"
            >
              toWin
            </text>
          </g>
        )}
      </svg>
    );*/
  }
  
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 190 60" 
      xmlns="http://www.w3.org/2000/svg"
      className="transition-colors duration-300"
      aria-label="Communicate to Win Logo"
    >
      {/* 对话气泡和对勾图标 */}
      <g transform="translate(5, 5) scale(0.25)">
        {/* 对话气泡 */}
        <path 
          d="M20,20 h160 a10,10 0 0 1 10,10 v80 a10,10 0 0 1 -10,10 h-100 l-30,30 v-30 h-30 a10,10 0 0 1 -10,-10 v-80 a10,10 0 0 1 10,-10 z" 
          fill={iconColor}
          className="transition-colors duration-300"
        />
        {/* 与header背景色匹配的对勾 */}
        <path 
          d="M20,20 L100,140 L180,20" 
          fill="none" 
          stroke={checkColor}
          strokeWidth="15" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          className="transition-colors duration-300"
        />
      </g>
      
      {/* 文字部分 */}
      {showText && (
        <g transform="translate(65, 0)">
          <text 
            x="0" 
            y="25" 
            fontFamily="sans-serif" 
            fontSize="18" 
            fontWeight="bold"
            fill={textColor}
            className="transition-colors duration-300"
          >
            Communicate
          </text>
          <text 
            x="0" 
            y="48" 
            fontFamily="Arial, Helvetica, sans-serif" 
            fontSize="28" 
            fontWeight="bold"
            fill={textColor}
            className="transition-colors duration-300"
          >
            toWin
          </text>
        </g>
      )}
    </svg>
  );
} 